const rootState = {
  currentCategory: '',
};

export default rootState;
